
import React from "react";
import CategoryFilter from "@/components/CategoryFilter";
import FilterContainer from "./filters/FilterContainer";
import RegionFilter from "./filters/RegionFilter";
import CityFilter from "./filters/CityFilter";
import { BusinessCategoryString } from "@/types/business";

interface FiltersSidebarProps {
  activeCategory: string | undefined;
  setActiveCategory: (category: string | undefined) => void;
  regionFilter: string | undefined;
  setRegionFilter: (region: string | undefined) => void;
  cityFilter: string | undefined;
  setCityFilter: (city: string | undefined) => void;
  cities: string[];
  availableRegions: string[];
}

const FiltersSidebar: React.FC<FiltersSidebarProps> = ({
  activeCategory,
  setActiveCategory,
  regionFilter,
  setRegionFilter,
  cityFilter,
  setCityFilter,
  cities,
  availableRegions,
}) => {
  return (
    <FilterContainer>
      <CategoryFilter 
        activeCategory={activeCategory as BusinessCategoryString} 
        setActiveCategory={setActiveCategory} 
      />
      
      <RegionFilter
        regionFilter={regionFilter}
        setRegionFilter={setRegionFilter}
        availableRegions={availableRegions}
      />
      
      <CityFilter
        cityFilter={cityFilter}
        setCityFilter={setCityFilter}
        cities={cities}
      />
    </FilterContainer>
  );
};

export default FiltersSidebar;
